import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { Merchant } from "../../models/merchant";
import { CoreService } from "../../services/core.service";
import { NgClass, NgStyle } from "@angular/common";
@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  standalone: true,
  imports: [NgClass, NgStyle],
})
// Component to display the header
export class HeaderComponent implements OnChanges, OnInit {
  @Input() Merchant: Merchant; // Input property to store Merchant data
  @Input() Home: Boolean; // Input property to determine if it's the Home page
  @Input() Product: Boolean; // Input property to determine if it's the Home page
  @Input() About: Boolean; // Input property to determine if it's the Home page
  @Input() Category: Boolean; // Input property to determine if it's the Home page
  @Input() TabCategory: Boolean; // Input property to determine if it's the Home page
  @Input() Basket: Boolean; // Input property to determine if it's the Home paged
  @Input() PaymentScreen: Boolean; // Input property to determine if it's the Home paged

  viewMode: "grid" | "map" = "grid";

  constructor(private coreService: CoreService) {
    // Constructor to inject CoreService dependency
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Lifecycle hook to handle input property changes
    if (CoreService.MultiOutlet) {
      // Check if the app has multi-outlet functionality
      if (
        this.coreService.stcurrentUrl == "/" ||
        this.coreService.stcurrentUrl.includes("/dashboard") ||
        this.coreService.stcurrentUrl.includes("/login")
      ) {
        // Check if the current URL is either the homepage, dashboard, or login page
        this.Home = true; // Set Home to true
        this.Product = false;
        this.About = false;
        this.Category = false;
        this.Basket = false;
        this.PaymentScreen = false;
      } else if (
        this.coreService.stcurrentUrl.includes("/products") ||
        this.coreService.stcurrentUrl.includes("/new-category")
      ) {
        this.Home = false;
        this.Product = true;
        this.About = false;
        this.Category = false;
        this.Basket = false;
        this.PaymentScreen = false;
      } else if (this.coreService.stcurrentUrl.includes("/about")) {
        this.Home = true;
        this.Product = false;
        this.About = true;
        this.Category = false;
        this.Basket = false;
        this.PaymentScreen = false;
      } else if (
        this.coreService.stcurrentUrl.includes("/category") ||
        this.coreService.stcurrentUrl.includes("/categories")
      ) {
        this.Home = true;
        this.Product = false;
        this.About = false;
        this.Category = true;
        this.Basket = false;
        this.PaymentScreen = false;
      } else if (
        this.coreService.stcurrentUrl.includes("/basket") ||
        this.coreService.stcurrentUrl.includes("/receipt")
      ) {
        this.Home = false;
        this.Product = false;
        this.About = false;
        this.Category = false;
        this.Basket = true;
        this.PaymentScreen = false;
      } else if (this.coreService.stcurrentUrl.includes("/fulfillment")) {
        this.Home = false;
        this.Product = false;
        this.About = false;
        this.Category = false;
        this.Basket = true;
        this.PaymentScreen = false;
      } else if (this.coreService.stcurrentUrl.includes("/pay")) {
        this.Home = false;
        this.Product = false;
        this.About = false;
        this.Category = false;
        this.Basket = true;
        this.PaymentScreen = true;
      } else {
        this.Home = false; // Otherwise, set Home to false
        this.Product = false;
        this.About = false;
        this.Category = false;
        this.Basket = false;
        this.PaymentScreen = false;
      }
    }

    // Un-Comment this
    if (
      this.coreService.stcurrentUrl == "/" ||
      this.coreService.stcurrentUrl.includes("/dashboard") ||
      this.coreService.stcurrentUrl.includes("/login")
    ) {
      // Check if the current URL is either the homepage, dashboard, or login page
      this.Home = true; // Set Home to true
      this.Product = false;
      this.About = false;
      this.Category = false;
      this.Basket = false;
      this.PaymentScreen = false;
      this.TabCategory = false;
    } else if (this.coreService.stcurrentUrl.includes("/products")) {
      this.Home = false;
      this.Product = true;
      this.About = false;
      this.Category = false;
      this.Basket = false;
      this.PaymentScreen = false;
      this.TabCategory = false;
    } else if (this.coreService.stcurrentUrl.includes("/about")) {
      this.Home = true;
      this.Product = false;
      this.About = true;
      this.Category = false;
      this.Basket = false;
      this.TabCategory = false;
    } else if (this.coreService.stcurrentUrl.includes("/category")) {
      this.Home = true;
      this.Product = false;
      this.About = false;
      this.Category = true;
      this.Basket = false;
      this.TabCategory = false;
    } else if (
      this.coreService.stcurrentUrl.includes("/subcategory") ||
      this.coreService.stcurrentUrl.includes("/nastedcategory")
    ) {
      this.Home = true;
      this.Product = false;
      this.About = false;
      this.Category = true;
      this.Basket = false;
      this.TabCategory = false;
    } else if (
      this.coreService.stcurrentUrl.includes("/basket") ||
      this.coreService.stcurrentUrl.includes("/receipt")
    ) {
      this.Home = false;
      this.Product = false;
      this.About = false;
      this.Category = false;
      this.Basket = true;
      this.PaymentScreen = false;
      this.TabCategory = false;
    } else if (this.coreService.stcurrentUrl.includes("/fulfillment")) {
      this.Home = false;
      this.Product = false;
      this.About = false;
      this.Category = false;
      this.Basket = true;
      this.PaymentScreen = false;
      this.TabCategory = false;
    } else if (this.coreService.stcurrentUrl.includes("/pay")) {
      this.Home = false;
      this.Product = false;
      this.About = false;
      this.Category = false;
      this.Basket = false;
      this.TabCategory = false;
      this.PaymentScreen = true;
    } else if (this.coreService.stcurrentUrl.includes("/new-category")) {
      this.Home = false;
      this.Product = false;
      this.About = false;
      this.Category = false;
      this.TabCategory = true;
      this.Basket = false;
      this.PaymentScreen = false;
    } else {
      this.Product = false;
      this.About = false;
      this.Category = false;
      this.Basket = false;
      this.PaymentScreen = false;
      this.TabCategory = false;
    }
  }

  ngOnInit() {
    this.viewMode =
      sessionStorage.getItem("home_view_mode") === "map" ? "map" : "grid";
  }

  setViewMode(mode: "grid" | "map") {
    this.viewMode = mode;
    sessionStorage.setItem("home_view_mode", mode);
    sessionStorage.setItem("home_view_state_initialized", "1");
    window.dispatchEvent(
      new CustomEvent("home-view-mode-changed", { detail: { mode } }),
    );
  }
}
